import { Link } from "react-router-dom";
import { ArrowUpRight, User, Building2 } from "lucide-react";
import SectionHeading from "@/components/SectionHeading";
import { StaggerGroup, StaggerItem } from "@/components/motion";
import { CAREER_SERVICES, ORG_SERVICES } from "@/data/site";

const HOME_SERVICES = [
  ...CAREER_SERVICES.slice(0, 4),
  ...ORG_SERVICES.slice(0, 4).map((s) => ({ ...s, category: "organisation" })),
];

export default function ServicesGrid() {
  return (
    <section data-testid="services-grid" className="bg-[#FEF7F2] py-8">
      <div className="nc-container">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="Our Services"
            title={<>Everything you need to take the <span className="text-[#142A5E]">next step.</span></>}
            subtitle="Two audiences. One team. Tailored to what you actually need."
          />
          <Link
            to="/services"
            data-testid="services-view-all"
            className="group inline-flex items-center gap-2 self-start rounded-full bg-[#142A5E] px-5 py-3 font-semibold text-white transition-colors hover:bg-[#1c3a7a] md:self-end"
          >
            View all services
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>

        <StaggerGroup className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {HOME_SERVICES.map((s) => (
            <StaggerItem key={s.title}>
              <div
                data-testid={`service-card-${s.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="group relative h-full overflow-hidden rounded-2xl border border-[#e7e9ef] bg-white p-6 transition-[transform,box-shadow,border-color] duration-400 hover:-translate-y-1.5 hover:border-[#142A5E]/30 hover:shadow-[0_24px_48px_-24px_rgba(29,61,143,0.35)]"
              >
                <span className="absolute right-0 top-0 h-16 w-16 translate-x-8 -translate-y-8 rounded-full bg-[#2FA86A]/10 transition-transform duration-500 group-hover:translate-x-6 group-hover:-translate-y-6" />
                <div className="relative flex items-start justify-between">
                  <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#142A5E]/8 text-[#142A5E] transition-colors duration-300 group-hover:bg-[#142A5E] group-hover:text-white">
                    <s.icon className="h-6 w-6" strokeWidth={1.75} />
                  </div>
                  {s.category && (
                    <span
                      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ${s.category === "organisation"
                          ? "bg-[#142A5E]/8 text-[#142A5E]"
                          : "bg-[#2FA86A]/10 text-[#2FA86A]"
                        }`}
                    >
                      {s.category === "organisation" ? (
                        <Building2 className="h-3.5 w-3.5" />
                      ) : (
                        <User className="h-3.5 w-3.5" />
                      )}
                    </span>
                  )}
                </div>
                <h3 className="relative mt-5 font-display text-lg font-bold text-[#1B1B1B]">{s.title}</h3>
                <p className="relative mt-2 text-sm leading-relaxed text-[#1B1B1B]/60">{s.desc}</p>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>

        {/* <div className="mt-10 flex flex-col items-center gap-3 rounded-2xl border border-[#142A5E]/10 bg-white/60 px-6 py-6 text-center">
          <p className="max-w-2xl text-sm leading-relaxed text-[#1B1B1B]/60">
            North Cadence also partners with startups, SMEs, and growing organisations on
            recruitment, RPO, talent acquisition, business development, hiring strategy
            &amp; workforce planning, and HR &amp; payroll. Enquire to scope an engagement
            with our team.
          </p>
          <Link
            to="/services"
            data-testid="services-org-enquire"
            className="text-sm font-semibold text-[#142A5E] hover:underline"
          >
            Organisational enquiries →
          </Link>
        </div> */}
      </div>
    </section>
  );
}
